(function () {
    const THRESHOLD = 40000;
    const GWP_PROP = '_gwp';
    const CAP_HANDLES = [
        'logo-cap-beige',
        'logo-cap-black',
        'logo-cap-white',
        'logo-cap-navy',
        'logo-cap-hot-pink',
    ];
 
    let capProducts = [];
    let isSyncing = false;
    let isQualified = false;
    let currentGwpHandle = null;
 
    async function loadCapProducts() {
        const results = await Promise.all(
            CAP_HANDLES.map(function (handle) {
                return fetch('/products/' + handle + '.js')
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (p) {
                    if (!p || !p.variants || !p.variants.length) return null;
                    const variant = p.variants[0];
                    return {
                        handle: handle,
                        title: p.title,
                        variantId: variant.id,
                        available: variant.available === true,
                    };
                })
                .catch(function () { return null; });
            })
        );
        capProducts = results.filter(Boolean);
    }
 
    async function refreshCapAvailability() {
        await Promise.all(
            capProducts.map(function (cap) {
                return fetch('/products/' + cap.handle + '.js')
                    .then(function (r) { return r.ok ? r.json() : null; })
                    .then(function (p) {
                        if (!p || !p.variants || !p.variants.length) {
                            cap.available = false;
                            return;
                        }
                        cap.variantId = p.variants[0].id;
                        cap.available = p.variants[0].available === true;
                    })
                    .catch(function () { cap.available = false; });
            })
        );
    }
 
    function getAvailableCaps() {
        return capProducts.filter(function (c) { return c.available; });
    }
 
    async function fetchCart() {
        return fetch('/cart.js').then(function (r) { return r.json(); });
    }
 
    function isGwpItem(item) {
        return item.properties && item.properties[GWP_PROP] === 'true';
    }
 
    function getRegularTotal(cart) {
        return cart.items.reduce(function (sum, item) {
            if (isGwpItem(item)) return sum;
            if (item.compare_at_price && item.compare_at_price > item.price) return sum;
            return sum + item.line_price;
        }, 0);
    }
 
    function findGwpItem(cart) {
        return cart.items.find(isGwpItem) || null;
    }
 
    async function addGwp(variantId) {
        const props = {};
        props[GWP_PROP] = 'true';
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, properties: props }),
        }).then(function (r) {
            if (!r.ok) {
                return r.json().then(function (err) {
                    throw new Error('add failed: ' + (err && err.description ? err.description : r.status));
                });
            }
            return r.json();
        });
    }
 
    async function removeGwp(lineNumber) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: lineNumber, quantity: 0 }),
        }).then(function (r) { return r.json(); });
    }
 
    function refreshCartUI() {
        const el = document.querySelector('cart-drawer-items');
        if (el && typeof el.onCartUpdate === 'function') {
            el.onCartUpdate();
        }
    }
 
    function removeDropdown() {
        const el = document.getElementById('gwp-selector-wrapper');
        if (el) el.remove();
    }
 
    function syncDropdown() {
        const availableCaps = getAvailableCaps();
 
        if (!isQualified || !availableCaps.length) {
            removeDropdown();
            return;
        }
 
        const existing = document.getElementById('gwp-selector-wrapper');
        if (existing) {
            const select = existing.querySelector('#gwp-variant-select');
            if (select) {
                rebuildOptions(select, availableCaps);
            }
            return;
        }
 
        const wrapper = document.querySelector('.drawer-progress-bar__wrapper');
        if (!wrapper) return;
 
        const div = document.createElement('div');
        div.id = 'gwp-selector-wrapper';
        div.style.cssText = 'padding: 8px 12px; display: flex; align-items: center; gap: 10px; font-size: 13px;';
 
        const label = document.createElement('label');
        label.setAttribute('for', 'gwp-variant-select');
        label.textContent = 'Choose your gift color:';
 
        const select = document.createElement('select');
        select.id = 'gwp-variant-select';
        select.style.cssText = 'border: 1px solid #ccc; padding: 4px 8px; font-size: 13px; cursor: pointer;';
 
        rebuildOptions(select, availableCaps);
 
        div.appendChild(label);
        div.appendChild(select);
        wrapper.insertAdjacentElement('afterend', div);
    }
 
    function rebuildOptions(select, availableCaps) {
        const previousValue = select.value;
        select.innerHTML = '';
 
        availableCaps.forEach(function (cap) {
            const option = document.createElement('option');
            option.value = cap.variantId;
            const parts = cap.title.split(' - ');
            option.textContent = parts.length > 1 ? parts[parts.length - 1] : cap.title;
            if (cap.handle === currentGwpHandle) option.selected = true;
            select.appendChild(option);
        });
 
        if (previousValue && select.querySelector('option[value="' + previousValue + '"]')) {
            select.value = previousValue;
        }
    }
 
    async function syncGwp() {
        if (isSyncing) return;
        isSyncing = true;
        try {
            await refreshCapAvailability();
 
            const cart = await fetchCart();
            const total = getRegularTotal(cart);
            const gwpItem = findGwpItem(cart);
            const availableCaps = getAvailableCaps();
            isQualified = total >= THRESHOLD;
            currentGwpHandle = gwpItem ? gwpItem.product_handle : null;
 
            if (gwpItem) {
                const gwpCap = capProducts.find(function (c) { return c.handle === gwpItem.product_handle; });
                const gwpIsAvailable = gwpCap && gwpCap.available;
 
                if (!gwpIsAvailable) {
                    const lineNumber = cart.items.indexOf(gwpItem) + 1;
                    await removeGwp(lineNumber);
                    currentGwpHandle = null;
 
                    if (isQualified && availableCaps.length) {
                        const fallback = availableCaps[0];
                        await addGwp(fallback.variantId);
                        currentGwpHandle = fallback.handle;
                        console.log(cart.items)
                    }
                    refreshCartUI();
                    syncDropdown();
                    return;
                }
            }
 
            if (isQualified && !gwpItem) {
                if (availableCaps.length) {
                    const defaultCap = availableCaps[0];
                    await addGwp(defaultCap.variantId);
                    currentGwpHandle = defaultCap.handle;
                    refreshCartUI();
                }
            } else if (!isQualified && gwpItem) {
                const lineNumber = cart.items.indexOf(gwpItem) + 1;
                await removeGwp(lineNumber);
                currentGwpHandle = null;
                refreshCartUI();
            }
 
            syncDropdown();
        } catch (err) {
            console.error('[cart-gwp] sync error:', err);
        } finally {
            isSyncing = false;
        }
    }
 
    async function handleVariantChange(newVariantId) {
        if (isSyncing) return;
        isSyncing = true;
        try {
            const targetCap = capProducts.find(function (c) { return c.variantId === newVariantId; });
            if (!targetCap || !targetCap.available) {
                await refreshCapAvailability();
                syncDropdown();
                return;
            }
 
            const cart = await fetchCart();
            const gwpItem = findGwpItem(cart);
            if (gwpItem) {
                const lineNumber = cart.items.indexOf(gwpItem) + 1;
                await removeGwp(lineNumber);
            }
            await addGwp(newVariantId);
            currentGwpHandle = targetCap.handle;
            refreshCartUI();
        } catch (err) {
            console.error('[cart-gwp] variant change error:', err);
        } finally {
            isSyncing = false;
        }
    }
 
    document.addEventListener('change', function (e) {
        if (!e.target || e.target.id !== 'gwp-variant-select') return;
        handleVariantChange(parseInt(e.target.value, 10));
    });
 
    var mutationTimer = null;
    new MutationObserver(function () {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(syncDropdown, 100);
    }).observe(document.body, { childList: true, subtree: true });
 
    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
            syncGwp();
        });
    }
 
    async function init() {
        await loadCapProducts();
        await syncGwp();
    }
 
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();